// extracted by mini-css-extract-plugin
module.exports = {"logo":"header-module--logo--dkMqu","menuMain":"header-module--menuMain--3vYE3","current":"header-module--current--kh60R","social":"header-module--social--3yN6D"};